import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpParams, HttpContextToken, HttpContext } from '@angular/common/http';
import { ComprobanteModel } from '../../models/comprobante/comprobante.model';
import { SolicitudModel } from 'src/app/shared/models/comprobante/solicitud.model';
import { DetalleMovimientoModel } from 'src/app/shared/models/comprobante/detalleMovimiento';
import { AuthService } from '../auth/auth.service';
import { ConfigService } from '../config.service';
import { catchError, concatMap, map, mergeMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ParamsModel } from '../../models/comprobante/params.model';

// Cuando se implemente el error interceptor, mover esto allí
const IGNORE_ERROR = new HttpContextToken<boolean>(() => false);

@Injectable({
  providedIn: 'root'
})
export class ComprobanteService {

  private url = this.configService.config.servidor?.api_cart;

  private baseUrl = this.configService.config.servidor?.api_server;
  private accessToken: string = this.authService.usuario.token;
  
  constructor(private http: HttpClient, private configService: ConfigService, private authService: AuthService) { }

  getComprobantes(parametros:Object){
    // const url = `${this.baseUrl}/ComprobanteVenta`; //PM CATFER-12 
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.COMPROBANTE.VERSION + this.configService.resource.COMPROBANTE.PATH_BASE;
    let params = {};
    {Object.assign(params, parametros);}
    //{Object.assign(params, {Access_Token: this.accessToken, Plataforma: 2});}
    // console.log(params);
    return this.http.get<[ComprobanteModel]>(url, {params: params});
  }

  getComprobanteId(id:number){
    // const url = `${this.baseUrl}/ComprobanteVenta/${id}`; //PM CATFER-12 
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.COMPROBANTE.GET_COMPROBANTE.VERSION + this.configService.resource.COMPROBANTE.PATH_BASE + this.configService.resource.COMPROBANTE.GET_COMPROBANTE.PATH_REL.replace('{id_comprobante}', id);
    let params = {};
    {Object.assign(params);}
    //{Object.assign(params, {Access_Token: this.accessToken, Plataforma: 2});}
    // console.log(params);
    return this.http.get<ComprobanteModel>(url, {params: params});
  }
  getComprobanteReciboId(id:number){
    // const url = `${this.baseUrl}/ComprobanteVenta/recibo/${id}`; //PM CATFER-12 
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.COMPROBANTE.GET_RECIBO.VERSION + this.configService.resource.COMPROBANTE.PATH_BASE + this.configService.resource.COMPROBANTE.GET_RECIBO.PATH_REL.replace('{id_comprobante}',id);
    let params = {};
    {Object.assign(params);}
    //{Object.assign(params, {Access_Token: this.accessToken, Plataforma: 2});}
    // console.log(params);
    return this.http.get<[ComprobanteModel]>(url, {params: params});
  }
  solicitarComprobante(body:Object){
    // const url = `${this.baseUrl}/ComprobanteVenta/GenerarPDF`;
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.COMPROBANTE.SOLICITAR_COMPROBANTE.VERSION + this.configService.resource.COMPROBANTE.PATH_BASE + this.configService.resource.COMPROBANTE.SOLICITAR_COMPROBANTE.PATH_REL;
    let params = {};
    // {Object.assign(params, {Access_Token: this.accessToken, Plataforma: 2});}
    return this.http.post<SolicitudModel>(url, body, {params: params});
  }
  verificarArchivo(url: string, error?: boolean){
   return this.http.get(url,{observe: 'response', context: error? new HttpContext().set(IGNORE_ERROR, true): null}).pipe(
    map(resp => resp),
    catchError( err => of(err) )
  )
    //  .subscribe(response => {
   
    //    // You can access status:
    //    console.log(response);
   

    //  });
  }
  //SC CATFER-17 se define funcion para obtener los comprobantes pendiente despacho.
  // parametros: filtros aplicables para los comprobantes pendiente despacho.
// incluirPresupuesto: indica si se desea incluir los items de los acopios que posean presupuesto asociados materiales.
  getPendientesDespacho(parametros:ParamsModel, incluirPresupuesto:boolean = false){
    // const url = `${this.baseUrl}/ComprobanteVenta/PendienteDespacho`;
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.COMPROBANTE.GET_PENDIENTES_DESPACHO.VERSION + this.configService.resource.COMPROBANTE.PATH_BASE + this.configService.resource.COMPROBANTE.GET_PENDIENTES_DESPACHO.PATH_REL;
    let params = {};
    {Object.assign(params, parametros);}
    return this.http.get<ComprobanteModel>(url, {params: params})
    .pipe(
      map((resp)=>{
        console.log(resp);
        if(resp.Data!.length > 0 && incluirPresupuesto){
           resp.Data.forEach(c => {
             if(c.EsAcopio === "S" && c.Acopio.IdPresupuestoAsociado != null){
               let articulosPresupuesto: any;
               this.getComprobanteId(c.Acopio.IdPresupuestoAsociado).subscribe((r)=>{
                articulosPresupuesto = r.Data;
                console.log(articulosPresupuesto);
               })
              setTimeout(() => {
                articulosPresupuesto.Articulos.forEach(element => {
                  let descArticulo = (element.PrecioFinal - (element.PrecioFinal * element.PjeDescuento / 100 ));
                      element.PrecioFinalConDesc = (descArticulo - (descArticulo * articulosPresupuesto.PjeDescuento / 100 ));
                      element.CantidadEnviar = 0;
                      element.IdVentaArticulo = element.Id;
                    c.Articulos.push(element);
                });
              }, 1000);
             }
           })
          }
        return resp;
      })
    );
  }

  // getPendientesDespacho(
  //   parametros: ParamsModel,
  //   incluirPresupuesto: boolean = false
  // ) {
  //   const url = `${this.baseUrl}/ComprobanteVenta/PendienteDespacho`;
  //   let params = {};
  //   {
  //     Object.assign(params, parametros);
  //   }
  
  //   return this.http.get(url, { params: params }).pipe(
  //     map((resp) => {
  //       if (resp.Data!.length > 0 && incluirPresupuesto) {
  //         return resp.Data!.pipe(
  //           concatMap((comprobante) => {
  //             if (
  //               comprobante.EsAcopio === 'S' &&
  //               comprobante.Acopio.IdPresupuestoAsociado > 0
  //             ) {
  //               return this.getComprobanteId(
  //                 comprobante.Acopio.IdPresupuestoAsociado
  //               ).pipe(
  //                 map((r) => ({ comprobante, articulosPresupuesto: r.Data }))
  //               );
  //             } else {
  //               return of({
  //                 comprobante,
  //                 articulosPresupuesto: null,
  //               });
  //             }
  //           }),
  //           mergeMap(({ comprobante, articulosPresupuesto }) => {
  //             const updatedComprobante = Object.assign({}, comprobante);
  //             if (articulosPresupuesto) {
  //               updatedComprobante.Articulos = articulosPresupuesto.Articulos.map(
  //                 (articulo) => {
  //                   const descArticulo = (articulo.PrecioFinal -
  //                     (articulo.PrecioFinal * articulo.PjeDescuento / 100));
  //                   articulo.PrecioFinalConDesc = (descArticulo -
  //                     (descArticulo * articulosPresupuesto.PjeDescuento / 100));
  //                   articulo.CantidadEnviar = 0;
  //                   articulo.IdVentaArticulo = articulo.Id;
  //                   return articulo;
  //                 }
  //               );
  //             }
  //             return of(updatedComprobante);
  //           }),
  //           merge()
  //         );
  //       } else {
  //         return of(resp.Data!);
  //       }
  //     })
  //   );
  // }

  getTrazabilidad(idComp: number){
    // const url = `${this.baseUrl}/ComprobanteVenta/${idComp}/Trazabilidad`;
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.COMPROBANTE.GET_TRAZABILIDAD.VERSION + this.configService.resource.COMPROBANTE.PATH_BASE + this.configService.resource.COMPROBANTE.GET_TRAZABILIDAD.PATH_REL.replace('{id_comprobante}', idComp);
    return this.http.get<[ComprobanteModel]>(url);  
  }

  getDetalleMovimiento(idComp:number, idVentaarticulo: number){
    // const url = `${this.baseUrl}/ComprobanteVenta/${idComp}/DetalleMovimientos`;
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.COMPROBANTE.GET_DETALLE_MOVIMIENTOS.VERSION + this.configService.resource.COMPROBANTE.PATH_BASE + this.configService.resource.COMPROBANTE.GET_DETALLE_MOVIMIENTOS.PATH_REL.replace('{id_comprobante}', idComp);
    let params = {};
    {Object.assign(params, {idVentaArticulo:idVentaarticulo});}
    return this.http.get<DetalleMovimientoModel>(url, {params: params});
  }

}
